<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
        <path
            d="M1.41797 7.47421L14.5608 1.49707"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M12.1035 0.571289L14.5607 1.497L13.6464 3.95415"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M15.1423 15.4284H12.2852V7.42836C12.2852 7.27681 12.3454 7.13146 12.4525 7.02431C12.5597 6.91714 12.705 6.85693 12.8566 6.85693H14.5709C14.7224 6.85693 14.8678 6.91714 14.975 7.02431C15.0821 7.13146 15.1423 7.27681 15.1423 7.42836V15.4284Z"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M9.42941 15.4284H6.57227V9.14272C6.57227 8.99116 6.63247 8.84581 6.73964 8.73866C6.84679 8.63149 6.99214 8.57129 7.14369 8.57129H8.85798C9.00953 8.57129 9.15488 8.63149 9.26204 8.73866C9.3692 8.84581 9.42941 8.99116 9.42941 9.14272V15.4284Z"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M3.71456 15.4285H0.857422V10.8571C0.857422 10.7055 0.917626 10.5602 1.02479 10.453C1.13195 10.3459 1.2773 10.2856 1.42885 10.2856H3.14314C3.29469 10.2856 3.44004 10.3459 3.54719 10.453C3.65436 10.5602 3.71456 10.7055 3.71456 10.8571V15.4285Z"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
